import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { closeModal } from "../../../utils/annual-planner-helpers";
import Modal from "../../modal-new";
import { buildMovementOptionsArray } from "../profile/AddGoal";
import { BodyweightGoalSection } from "./parts/BodyweightGoalSection";
import { PersonalRecordGoalsSection } from "./parts/PersonalRecordGoalsSection";

// See ~/.claude/plans/periodization-add-goal-modal.md. Every action here
// (Bodyweight's inline form, PR's inline add/edit forms, PR's visibility
// checkbox) submits immediately on its own - there's no staged/batched state
// in this modal, so the footer button just closes it.
export const ManageMilestoneGoalsModal = ({ locals }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const {
    clientGoals = [],
    activeUser,
    activeUserToRequest,
    query,
    assert,
    flash,
  } = locals;
  const units = activeUser?.units;
  const movementOptions = buildMovementOptionsArray(activeUserToRequest, t);

  return (
    <Modal
      className="annual-planner-modal manage-milestone-goals-modal"
      title={t("annualPlanner.addGoalModalTitle")}
    >
      <div className="body">
        <BodyweightGoalSection
          clientGoals={clientGoals}
          units={units}
          query={query}
          assert={assert}
          flash={flash}
        />
        <PersonalRecordGoalsSection
          clientGoals={clientGoals}
          units={units}
          query={query}
          assert={assert}
          flash={flash}
          movementOptions={movementOptions}
          t={t}
        />
      </div>
      <footer className="manage-milestone-goals-footer">
        <span className="chip info">
          {t("annualPlanner.hideGoalFromPlannerHint")}
        </span>
        <div className="footer-right">
          <button type="button" data-button-type="primary" onClick={closeModal}>
            {t("common:done")}
          </button>
        </div>
      </footer>
    </Modal>
  );
};

ManageMilestoneGoalsModal.propTypes = {
  locals: PropTypes.object.isRequired,
};
